import {constant} from 'lodash/fp';

import {FETCH_REMOTE_CONFIG} from '/enum/launchSequence.enum';
import {getVariables} from '/redux/action/remoteConfig.action';
import {completedStepByName} from '/redux/selector/launchSequence.selector';
import {withProps} from '/util/selector.util';

export const fetchRemoteConfigTask = {
  stepName: FETCH_REMOTE_CONFIG,
  isCompleted: ({state}: any) =>
    // @ts-expect-error TS(2554): Expected 2 arguments, but got 1.
    withProps({stepName: FETCH_REMOTE_CONFIG})(completedStepByName)(state),
  perform: ({dispatch}: any) =>
    // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
    dispatch(getVariables()).catch(constant(undefined)),
};
